import React from 'react';
import styled from 'styled-components';
import { useIsAdmin } from 'hooks/useRoleCheck';
import { TextButton } from 'components/v2/buttons';
import { ReactComponent as MessageIcon } from 'images/v2/icons/svg/fill/svg/message.svg';
import EpdRoutes from 'routes/EpdRoutes';
import { useDocumentCommentLog } from './useDocumentCommentLog';

const DocumentCommentLogButton: React.FC<{ docId: string }> = ({ docId }) => {
  const isAdmin = useIsAdmin();
  const { data } = useDocumentCommentLog(docId, isAdmin);

  if (!isAdmin || !data?.items.length) {
    return null;
  }

  return (
    <TextButton
      type="button"
      style={{ fontSize: 14, fontWeight: 500 }}
      text
      label="Comment log"
      icon={<StyledMessageIcon aria-hidden="true" />}
      onClick={() => window.open(EpdRoutes.param(EpdRoutes.dynamicFormCommentLog, ':docId', docId), '_blank', 'noopener,noreferrer')}
    />
  );
};

const StyledMessageIcon = styled(MessageIcon)`
  display: block;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  color: ${(props) => props.theme.colors.primaryOrange};

  button:hover & {
    color: ${(props) => props.theme.colors.elementsButtonHover};
  }
`;

export default DocumentCommentLogButton;
